import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" className={className}>
    <path fill="#000" d="M16.646 25V13.48l1.26 1.26h-3.78V12.4h5.436V25h-2.916z"></path>
    <circle cx="18" cy="18" r="17" stroke="#000" strokeWidth="2"></circle>
  </svg>
);

export default Icon;
